import BaseException from './base_exception'

class InvalidEnum extends BaseException {
  constructor(value, propertyName, validValues) {
    super('hs.errors.invalid_enum', {
      value: value,
      propertyName,
      validValues,
    })
  }
}

export default InvalidEnum
